import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BrushIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M7.13437 2.87201C7.0456 2.26947 7.52982 1.73053 8.1573 1.73053H9.90858C10.5361 1.73053 11.0203 2.26947 10.9315 2.87201L10.066 8.73053H10.5744C11.1393 8.73053 11.6639 8.95331 12.0432 9.32379C12.2813 9.55719 12.4629 9.84918 12.5597 10.1811L12.7211 10.7305H5.34476L5.50617 10.1811C5.75837 9.32245 6.56944 8.73053 7.49149 8.73053H7.99992L7.13437 2.87201Z"
		/>
		<path
			fill="currentColor"
			d="M5.03356 11.7305L3.00789 15.0932C2.91508 15.4125 3.66482 15.7305 4.00781 15.7305H4.54927C4.84039 15.7305 5.11706 15.6036 5.30703 15.383L6.76092 13.6947C6.83019 13.5271 7.0753 13.5271 7.14457 13.6947L6.91397 14.432C6.71254 15.076 7.19362 15.7305 7.86837 15.7305H8.58015C8.85971 15.7305 9.1265 15.6135 9.31585 15.4078L10.893 13.6947C10.9622 13.5271 11.2074 13.5271 11.2766 13.6947L10.8747 14.8363C10.7209 15.2729 11.0449 15.7305 11.5078 15.7305C11.8508 15.7305 12.5078 15.7305 12.4377 15.0932L13.0031 11.7305H5.03356Z"
		/>
	</svg>
))
